<div class="channel-header-row" *ngIf="mediaList || mediaList2">
	<div class="channel-header-row-text">
		<h3 class="main-channel-header channel-header mr-3 " tabindex="3">
			Continue Watching
		</h3>
	</div>
</div>
<ng-container *ngIf="mediaList">
	<app-image-slider-smart-tv [type]="'thumbs'" [items]="mediaList" [isContinueWatching]="true"
		(rowFocused)="rowFocused.emit()" [currentFocus]="currentFocus">
	</app-image-slider-smart-tv>
</ng-container>
<ng-container *ngIf="mediaList2">
	<app-image-slider-smart-tv [type]="'thumbs'" [items]="mediaList2" [isContinueWatching]="true"
		(rowFocused)="rowFocused.emit()" [currentFocus]="currentFocus">
	</app-image-slider-smart-tv>
</ng-container>